module.exports = __webpack_public_path__ + "static/img/ninja-can-15.56b6a4c4.png";